import { ORDER_REQUEST_MESSAGES, OrderRequestMessages } from "./order-request-messages";
import { ORDER_STATUS_MESSAGES, OrderStatusMessages } from "./order-status.messages";
import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { ADRESS_MESSAGES, AddressMessages } from "../address.messages";
import { DOCUMENT_MESSAGES, DocumentMessages } from "../document-messages";
import { GENDER_MESSAGES, GenderMessages } from "../gender/gender.messages";

export type OrderDataTabMessages = ActionButtonMessages &
  OrderRequestMessages &
  OrderStatusMessages &
  DocumentMessages &
  GenderMessages &
  AddressMessages & {
    // Group Titles
    groupCustomerTitle: string;
    groupDeliveryDataTitle: string;
    groupPaymentValuesTitle: string;
    orderInfoTitle: string;

    deliveryDialogTitle: string;
    deliveryDateLabel: string;

    // Invoiced dialog
    invoiceKeyLabel: string; // Chave de acesso
    invoiceNumberLabel: string; // Número
    invoiceSeriesLabel: string; // Serie
    invoiceXmlLabel: string; // XML
    invoiceDateLabel: string; // Data
    invoiceDialogTitle: string;

    // Shipping dialog
    shippingDialogTitle: string;
    shippingVolumeTypeLabel: string; //  Tipo volume
    shippingVolumesLabel: string; // Volumes
    shippingObjectLabel: string; // Código de rastreio
    shippingTrackingUrlLabel: string; // URL de rastreio

    // Field Labels
    orderNumberLabel: string;
    orderDateLabel: string;
    channelLabel: string;
    salesRepresentativeLabel: string;
    orderStatusLabel: string;

    documentTypeLabel: string;
    documentLabel: string;
    shippingNameLabel: string;
    shippingGenderLabel: string;
    shippingPhoneNumberLabel: string;
    shippingEmailLabel: string;

    shippingAddressZipcodeLabel: string;
    addressLabel: string;
    shippingAddressNumberLabel: string;
    shippingAddressComplLabel: string;
    shippingAddressDistrictLabel: string;
    shippingAddressCityLabel: string;
    shippingAddressStateLabel: string;
    shippingAddressCountryLabel: string;
    shippingAddressLabel: string;
    shippingAgentServiceLabel: string;

    // Error Messages
    cepNotFoundError: string;
    errorRequiredDocument: string;
    errorRequiredName: string;
    errorRequiredMobilePhone: string;
    errorRequiredEmail: string;
    errorRequiredZipCode: string;
    errorRequiredAddress: string;
    errorRequiredAddressNumber: string;
    errorRequiredDistrict: string;
    errorRequiredCity: string;
    errorRequiredState: string;
    errorRequiredCountry: string;
    errorRequiredShippingName: string;
    errorInvalidPhone: string;
    errorRequiredShippingDocument: string;
    invalidCPF: string;
    invalidRG: string;
    invalidCNPJ: string;
    errorInvalidEmail: string;
    errorRequiredPhone: string;
    errorRequiredShippingAddress: string;
    errorRequiredOrderStatus: string;
  };

export const ORDER_DATA_TAB_MESSAGES: OrderDataTabMessages = {
  // Group Titles
  groupCustomerTitle: "Cliente",
  groupDeliveryDataTitle: "Dados de Entrega",
  groupPaymentValuesTitle: "Valores do Pedido",
  orderInfoTitle: "Pedido",

  deliveryDialogTitle: "Dados de Entrega",
  deliveryDateLabel: "Data de Entrega",

  // Invoiced dialog
  invoiceKeyLabel: "Chave de acesso",
  invoiceNumberLabel: "Número",
  invoiceSeriesLabel: "Serie",
  invoiceXmlLabel: "XML",
  invoiceDateLabel: "Data",
  invoiceDialogTitle: "Dados da Nota Fiscal",

  // Shipping dialog
  shippingDialogTitle: "Dados de Envio",
  shippingVolumeTypeLabel: "Tipo volume",
  shippingVolumesLabel: "Volumes",
  shippingObjectLabel: "Código de rastreio",
  shippingTrackingUrlLabel: "URL de rastreio",

  // Field Labels
  orderNumberLabel: "Número do Pedido",
  orderDateLabel: "Data do Pedido",
  channelLabel: "Canal",
  salesRepresentativeLabel: "Representante de Vendas",
  orderStatusLabel: "Status do Pedido",

  documentTypeLabel: "Tipo do documento",
  documentLabel: "CPF/CNPJ",
  shippingNameLabel: "Nome",
  shippingGenderLabel: "Gênero",
  shippingPhoneNumberLabel: "Celular",
  shippingEmailLabel: "Email",

  shippingAddressZipcodeLabel: "CEP",
  addressLabel: "Endereço",
  shippingAddressNumberLabel: "Número",
  shippingAddressComplLabel: "Complemento",
  shippingAddressDistrictLabel: "Bairro",
  shippingAddressCityLabel: "Cidade",
  shippingAddressStateLabel: "Estado",
  shippingAddressCountryLabel: "País",
  shippingAddressLabel: "Endereço",
  shippingAgentServiceLabel: "Tipo de frete",

  // Error Messages
  cepNotFoundError: "Cep não encontrado",
  errorRequiredDocument: "O documento é obrigatório!",
  errorRequiredName: "O nome é obrigatório!",
  errorRequiredMobilePhone: "O celular é obrigatório!",
  errorRequiredEmail: "O email é obrigatório!",
  errorRequiredZipCode: "O CEP é obrigatório!",
  errorRequiredAddress: "O endereço é obrigatório!",
  errorRequiredAddressNumber: "O número do endereço é obrigatório!",
  errorRequiredDistrict: "O bairro é obrigatório!",
  errorRequiredCity: "A cidade é obrigatória!",
  errorRequiredState: "O estado é obrigatório!",
  errorRequiredCountry: "O país é obrigatório!",
  errorRequiredShippingName: "O nome de cobrança é obrigatório!",
  errorInvalidPhone: "O telefone informado é inválido!",
  errorRequiredShippingDocument: "O documento de cobrança é obrigatório!",
  errorInvalidEmail: "O email informado não é válido!",
  errorRequiredPhone: "O telefone é obrigatório!",
  errorRequiredShippingAddress: "O endereço de cobrança é obrigatório!",
  errorRequiredOrderStatus: "O status do pedido é obrigatório!",
  invalidCPF: "O CPF informado não é válido!",
  invalidRG: "O RG informado não é válido!",
  invalidCNPJ: "O CNPJ informado não é válido!",

  ...ADRESS_MESSAGES,
  ...GENDER_MESSAGES,
  ...DOCUMENT_MESSAGES,
  ...ORDER_STATUS_MESSAGES,
  ...ACTION_BUTTON_MESSAGES,
  ...ORDER_REQUEST_MESSAGES,
};
